import { render, staticRenderFns } from "./MissingBankCCsAfterOBKMigrationInsight.vue?vue&type=template&id=16b14732&scoped=true"
import script from "./MissingBankCCsAfterOBKMigrationInsight.vue?vue&type=script&lang=js"
export * from "./MissingBankCCsAfterOBKMigrationInsight.vue?vue&type=script&lang=js"
import style0 from "./MissingBankCCsAfterOBKMigrationInsight.vue?vue&type=style&index=0&id=16b14732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b14732",
  null
  
)

export default component.exports